import React, { Fragment, useState, useContext } from "react";
import { Range, getTrackBackground } from "react-range";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Collapse,
  Form,
  Input,
  Label,
} from "reactstrap";
import { CandidateSearchContext } from "../../../../CandidateSearch/CandidateSearchContext";
const Ctc = () => {
  const [isFilter, setIsFilter] = useState(true);
  const { filters, updateFilters } = useContext(CandidateSearchContext);

  const STEP = 1;
  const MIN = 0;
  const MAX = 100000000;

  const handleRangeChange = (newValues) => {
    //setValues(newValues);
    updateFilters({
      minctc: newValues[0],
      maxctc: newValues[1],
    });
  };

  // const handleInputChange = (key, event) => {
  //   const { value } = event.target;
  //   updateFilters({
  //     ...filters,
  //     [key]: parseInt(value),
  //   });
  // };

  const handleInputChange = (key, event) => {
    const { value } = event.target;
    // Allow empty string, otherwise parse to integer
    const numericValue = value === "" ? "" : parseInt(value, 10);

    // Prevent non-numeric or out-of-range values
    if (
      numericValue !== "" &&
      (isNaN(numericValue) || numericValue < MIN || numericValue > MAX)
    ) {
      return; // Exit if input is invalid
    }

    // Get the current values from the context
    let currentMin = filters.minctc;
    let currentMax = filters.maxctc;

    // Determine the new min and max values based on which input changed
    let newMin = key === "minctc" ? numericValue : currentMin;
    let newMax = key === "maxctc" ? numericValue : currentMax;

    // Use Number() for safe comparison, defaulting to 0 if the value is empty/null
    const comparableMin = Number(newMin || 0);
    const comparableMax = Number(newMax || 0);

    // --- VALIDATION LOGIC ---
    // If the new 'min' is greater than 'max', update 'max' to match the new 'min'
    if (key === "minctc" && comparableMin > comparableMax) {
      newMax = newMin;
    }

    // If the new 'max' is less than 'min', update 'min' to match the new 'max'
    // The `value !== ""` check prevents this from triggering when the max field is cleared
    if (key === "maxctc" && value !== "" && comparableMax < comparableMin) {
      newMin = newMax;
    }

    // Update the context with the validated values
    updateFilters({
      ...filters,
      minctc: newMin,
      maxctc: newMax,
    });
  };


  return (
    <Fragment>
      <Col xl="12">
        <Card>
          <CardHeader className="py-3" onClick={() => setIsFilter(!isFilter)}>
            <h5 className="mb-0 p-0">CTC (LPA)</h5>
          </CardHeader>
          <Collapse isOpen={isFilter}>
            <CardBody className="filter-cards-view animate-chk">
              <Form className="theme-form form-label-align-right range-slider">
                <Row className="mb-3 align-items-center">
                  <Col >
                    <Label>Min</Label>
                    <Input
                      type="number"
                      value={filters && filters.minctc}
                      // onChange={(e) => handleInputChange("minctc", e)}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Allow empty input or ensure the value is a valid number within the range
                        if (
                          value === "" ||
                          (value >= 0 && value <= 990000000)
                        ) {
                          handleInputChange("minctc", e); // Call your existing handleChange function
                        }
                      }}
                    />
                  </Col>
                  {/* <Col md="2" className="pt-5">
                    <span className="d-block">To</span>
                  </Col> */}
                  <Col >
                    <Label>Max</Label>
                    <Input
                      type="number"
                      value={filters && filters.maxctc}
                      // onChange={(e) => handleInputChange("maxctc", e)}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Allow empty input or ensure the value is a valid number within the range
                        if (
                          value === "" ||
                          (value >= 0 && value <= 990000000)
                        ) {
                          handleInputChange("maxctc", e); // Call your existing handleChange function
                        }
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mb-0">
                  <Col md="12">
                    <Range
                      values={[filters && filters.minctc, filters && filters.maxctc]}
                      step={STEP}
                      min={MIN}
                      max={MAX}
                      onChange={handleRangeChange}
                      renderTrack={({ props, children }) => (
                        <div
                          onMouseDown={props.onMouseDown}
                          onTouchStart={props.onTouchStart}
                          style={{
                            ...props.style,
                            height: "36px",
                            display: "flex",
                            width: "100%",
                          }}
                        >
                          <output style={{ marginTop: "12px" }}>
                            {/* {values[0]} */}
                          </output>
                          <div
                            ref={props.ref}
                            style={{
                              height: "5px",
                              width: "100%",
                              borderRadius: "4px",
                              background: getTrackBackground({
                                values: [filters && filters.minctc, filters && filters.maxctc],
                                colors: ["#ccc", "#7366ff", "#ccc"],
                                min: MIN,
                                max: MAX,
                              }),
                              alignSelf: "center",
                            }}
                          >
                            {children}
                          </div>
                          <output style={{ marginTop: "12px" }}>
                            {/* {values[1]} */}
                          </output>
                        </div>
                      )}
                      renderThumb={({ props, isDragged }) => (
                        <div
                          {...props}
                          style={{
                            ...props.style,
                            height: "35px",
                            width: "35px",
                            borderRadius: "30px",
                            backgroundColor: "#FFF",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            boxShadow: "0px 2px 6px #AAA",
                          }}
                        >
                          <div
                            style={{
                              height: "16px",
                              width: "5px",
                              backgroundColor: isDragged ? "#7366ff" : "#CCC",
                            }}
                          />
                        </div>
                      )}
                    />
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Collapse>
        </Card>
      </Col>
    </Fragment>
  );
};

export default Ctc;
